import React from "react";

function Loading({ show }) {
	return (
		<div
			style={{
				position: "relative",
			}}
		>
			{show && (
				<div
					className="overlay_container"
					style={{
						position: "absolute",
						top: 0,
						bottom: 0,
						left: 0,
						right: 0,
						zIndex: 99,
						background: "transparent",
					}}
				>
					<div className="loader"></div>
				</div>
			)}

			{/* <div className='waviy-container'>
        <div className='waviy'>
          <span style={{ color: "#2D266C", i: "1;" }} className='huruf-1'>
            a
          </span>
          <span style={{ color: "#2D266C", i: "2" }} className='huruf-2'>
            s
          </span>
          <span style={{ color: "#9BC025", i: "3" }} className='huruf-3'>
            h
          </span>
          <span style={{ color: "#2D266C", i: "4" }} className='huruf-4'>
            a
          </span>
        </div>
      </div> */}
		</div>
	);
}

export const SecondLoading = ({ show }) => {
	return (
		<div
			style={{
				position: "relative",
			}}
		>
			{show && (
				<div className="waviy">
					<span style={{ color: "#2D266C", i: "1;" }} className="huruf-1">
						a
					</span>
					<span style={{ color: "#2D266C", i: "2" }} className="huruf-2">
						s
					</span>
					<span style={{ color: "#9BC025", i: "3" }} className="huruf-3">
						h
					</span>
					<span style={{ color: "#2D266C", i: "4" }} className="huruf-4">
						a
					</span>
				</div>
			)}
		</div>
	);
};

export default Loading;
